function formatPostedDate(createdAt) {
  if (!createdAt) return 'Recently'

  const timestamp =
    typeof createdAt === 'number'
      ? createdAt
      : parseInt(createdAt, 10)

  if (!timestamp) return 'Recently'

  const days = Math.floor((Date.now() / 1000 - timestamp) / 86400)
  if (days <= 0) return 'Today'
  if (days === 1) return '1 day ago'
  return `${days} days ago`
}

function getProfessionTitles(items) {
  return (items || [])
    .map((item) => item?.profession?.title)
    .filter(Boolean)
}

function getContentTypeTitles(entity, prefix) {
  const key = `${prefix}ContentType`
  return (entity?.[key] || [])
    .map((item) => item?.contentType?.title)
    .filter(Boolean)
}

function mapPostFromApi(opp) {
  const raw = opp?.post || {}
  const isHire = opp?.postType === 'hire'
  const hire = raw.hire
  const pitch = raw.pitch
  const entity = isHire ? hire : pitch
  const user = entity?.user
  const location = entity?.locationOfProposedWork?.trim()

  const contentTypes = isHire
    ? getContentTypeTitles(hire, 'hire')
    : getContentTypeTitles(pitch, 'pitch')

  return {
    id: raw.postUniqueId || String(raw.id || ''),
    postType: opp.postType,
    pitchName: isHire
      ? hire?.title || 'Untitled'
      : pitch?.pitchName || 'Untitled',
    description: isHire
      ? hire?.message?.trim() || 'No description provided.'
      : pitch?.pitchDescription?.trim() ||
        pitch?.about?.trim() ||
        'No description provided.',
    desiredProfessionals: isHire
      ? getProfessionTitles(hire?.hireDesireProfession)
      : getProfessionTitles(pitch?.pitchDesireProfession),
    contentType: contentTypes[0] || 'Any',
    postedBy: user?.userName || user?.name || 'Unknown',
    country: 'Any',
    state: 'Any State',
    city: location || 'Any City',
    language: 'Any',
    postedDate: formatPostedDate(raw.createdAt),
    isNew: false,
    link: raw.shareUrl || entity?.shareUrl || '#',
    gender: hire?.hireGender?.[0]?.gender?.title || 'Any',
    age: hire?.age || null,
  }
}

function stripMarkdownEmphasis(value) {
  return String(value ?? '')
    .replace(/\*+/g, '')
    .trim()
}

export function mapOpportunityEngineOutput(output) {
  if (!output) return null

  const opps = (output.opportunities || []).map((opp) => ({
    post: mapPostFromApi(opp),
    score: opp.score || 0,
    label: opp.label || '',
    whyFit: opp.whyFit || '',
    howToApply: opp.howToApply || '',
  }))

  return {
    pulseTotal: stripMarkdownEmphasis(output.pulseTotal ?? '0') || '0',
    pulseMatch: stripMarkdownEmphasis(output.pulseMatch ?? '0') || '0',
    pulseStrong: stripMarkdownEmphasis(output.pulseStrong ?? '0') || '0',
    producerTip: Boolean(output.producerTip),
    advice: stripMarkdownEmphasis(output.advice || ''),
    opps,
  }
}
